// Material Dashboard 2 PRO React TS Base Styles
import colors from '@theme/base/colors';
import borders from '@theme/base/borders';
import boxShadows from '@theme/base/boxShadows';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from '@theme/functions/pxToRem';
import boxShadow from '@theme/functions/boxShadow';
import linearGradient from '@theme/functions/linearGradient';

const { grey, white, info, gradients } = colors;
const { borderRadius, borderWidth } = borders;
const { sliderBoxShadow } = boxShadows;

// types
type Types = any;

const slider: Types = {
  styleOverrides: {
    root: {
      width: '100%',

      '& .MuiSlider-active, & .Mui-focusVisible': {
        boxShadow: 'none !important'
      },

      '& .MuiSlider-valueLabel': {
        color: white.main
      },

      '& .MuiSlider-markLabel': {
        color: info.main
      },

      '&.Mui-disabled': {
        opacity: 0.4,
        '.MuiSlider-track': {
          background: grey[900]
        }
      }
    },

    valueLabel: {
      opacity: 0
    },
    rail: {
      height: pxToRem(10),
      background: grey[200],
      borderRadius: borderRadius.sm,
      opacity: 1
    },

    track: {
      background: linearGradient(
        gradients.primary.main,
        gradients.primary.state
      ),
      height: pxToRem(10),
      position: 'relative',
      border: 'none',
      borderRadius: borderRadius.lg,
      zIndex: 1
    },

    thumb: {
      width: pxToRem(14),
      height: pxToRem(14),
      backgroundColor: white.main,
      zIndex: 10,
      boxShadow: sliderBoxShadow.thumb,
      border: `${borderWidth[1]} solid ${info.main}`,
      transition: 'all 200ms linear',

      '&:hover': {
        boxShadow: 'none'
      },

      '&:active': {
        transform: 'translate(-50%, -50%) scale(1.4)'
      },

      '&.Mui-active': { boxShadow: boxShadow([0, 0], [0, 14], info.main, 0.16) }
    }
  }
};

export default slider;
